export default "__VITE_ASSET__BH7W7V6t__"